import * as React from "react";
import { Stack } from "@mui/material";
import { StatusCard } from "@/components/dashboard/StatusCard";
import { MetricCard } from "@/components/dashboard/MetricCard";
import { HealthBadge } from "@/components/dashboard/HealthBadge";
import { QueryStateBoundary } from "@/components/dashboard/QueryStateBoundary";
import { useCertificationReport } from "@/hooks/queries/useCertificationReport";
import { useBuildInfo } from "@/hooks/queries/useSystemInfo";

interface ScenarioResult {
  scenario_name: string;
  status: string;
}

interface CertificationReportPayload {
  overall_passed: boolean;
  scenario_results: ScenarioResult[];
}

interface BuildInfoPayload {
  data: { build_version: string };
}

/** Reuses Sprint 3.2's `useCertificationReport` hook - same "production_readiness" scenario lookup pattern as the Dashboard's CertificationSection. */
export function ProductionSection(): React.JSX.Element {
  const certificationQuery = useCertificationReport();
  const buildInfoQuery = useBuildInfo();

  return (
    <StatusCard title="Production">
      <Stack spacing={1.5}>
        <QueryStateBoundary query={certificationQuery}>
          {(payload) => {
            const report = payload as unknown as CertificationReportPayload;
            const productionReadinessScenario = report.scenario_results.find(
              (s) => s.scenario_name === "production_readiness",
            );
            return (
              <>
                <MetricCard
                  label="Certification Status"
                  render={<HealthBadge status={report.overall_passed ? "passed" : "failed"} />}
                />
                <MetricCard
                  label="Production Readiness"
                  render={<HealthBadge status={productionReadinessScenario?.status ?? null} />}
                />
              </>
            );
          }}
        </QueryStateBoundary>
        <QueryStateBoundary query={buildInfoQuery}>
          {(payload) => (
            <MetricCard
              label="Deployment Version"
              value={(payload as unknown as BuildInfoPayload).data?.build_version}
            />
          )}
        </QueryStateBoundary>
      </Stack>
    </StatusCard>
  );
}
